import * as we from "react";
import ct, { forwardRef as sr, useContext as Jt, useRef as _e, useEffect as Se, useState as fe, useMemo as tr, useCallback as nr, useImperativeHandle as Kt } from "react";
import { isObject as ze, mergeRefs as Xt } from "@illa-design/system";
import { getColor as Ge, applyBoxStyle as Zt } from "@illa-design/theme";
import { css as Re } from "@emotion/react";
import { useMotionValue as ut, motion as ft } from "framer-motion";
import { Trigger as Wr } from "@illa-design/trigger";
function Qt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var br = { exports: {} }, Ye = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ur;
function en() {
  if (Ur)
    return Ye;
  Ur = 1;
  var e = ct, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(f, s, v) {
    var l, d = {}, P = null, A = null;
    v !== void 0 && (P = "" + v), s.key !== void 0 && (P = "" + s.key), s.ref !== void 0 && (A = s.ref);
    for (l in s)
      o.call(s, l) && !i.hasOwnProperty(l) && (d[l] = s[l]);
    if (f && f.defaultProps)
      for (l in s = f.defaultProps, s)
        d[l] === void 0 && (d[l] = s[l]);
    return { $$typeof: r, type: f, key: P, ref: A, props: d, _owner: a.current };
  }
  return Ye.Fragment = t, Ye.jsx = u, Ye.jsxs = u, Ye;
}
var We = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gr;
function rn() {
  return Gr || (Gr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = ct, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), f = Symbol.for("react.context"), s = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), P = Symbol.for("react.lazy"), A = Symbol.for("react.offscreen"), k = Symbol.iterator, y = "@@iterator";
    function N(n) {
      if (n === null || typeof n != "object")
        return null;
      var c = k && n[k] || n[y];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(n) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), C = 1; C < c; C++)
          p[C - 1] = arguments[C];
        T("error", n, p);
      }
    }
    function T(n, c, p) {
      {
        var C = x.ReactDebugCurrentFrame, j = C.getStackAddendum();
        j !== "" && (c += "%s", p = p.concat([j]));
        var U = p.map(function(I) {
          return String(I);
        });
        U.unshift("Warning: " + c), Function.prototype.apply.call(console[n], console, U);
      }
    }
    var $ = !1, h = !1, M = !1, O = !1, de = !1, se;
    se = Symbol.for("react.module.reference");
    function q(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === o || n === i || de || n === a || n === v || n === l || O || n === A || $ || h || M || typeof n == "object" && n !== null && (n.$$typeof === P || n.$$typeof === d || n.$$typeof === u || n.$$typeof === f || n.$$typeof === s || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === se || n.getModuleId !== void 0));
    }
    function E(n, c, p) {
      var C = n.displayName;
      if (C)
        return C;
      var j = c.displayName || c.name || "";
      return j !== "" ? p + "(" + j + ")" : p;
    }
    function m(n) {
      return n.displayName || "Context";
    }
    function S(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case o:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case v:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case f:
            var c = n;
            return m(c) + ".Consumer";
          case u:
            var p = n;
            return m(p._context) + ".Provider";
          case s:
            return E(n, n.render, "ForwardRef");
          case d:
            var C = n.displayName || null;
            return C !== null ? C : S(n.type) || "Memo";
          case P: {
            var j = n, U = j._payload, I = j._init;
            try {
              return S(I(U));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var R = Object.assign, w = 0, _, F, L, Z, ce, xe, J;
    function Oe() {
    }
    Oe.__reactDisabledLog = !0;
    function Le() {
      {
        if (w === 0) {
          _ = console.log, F = console.info, L = console.warn, Z = console.error, ce = console.group, xe = console.groupCollapsed, J = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: Oe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        w++;
      }
    }
    function je() {
      {
        if (w--, w === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: R({}, n, {
              value: _
            }),
            info: R({}, n, {
              value: F
            }),
            warn: R({}, n, {
              value: L
            }),
            error: R({}, n, {
              value: Z
            }),
            group: R({}, n, {
              value: ce
            }),
            groupCollapsed: R({}, n, {
              value: xe
            }),
            groupEnd: R({}, n, {
              value: J
            })
          });
        }
        w < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var he = x.ReactCurrentDispatcher, Pe;
    function Ce(n, c, p) {
      {
        if (Pe === void 0)
          try {
            throw Error();
          } catch (j) {
            var C = j.stack.trim().match(/\n( *(at )?)/);
            Pe = C && C[1] || "";
          }
        return `
` + Pe + n;
      }
    }
    var pe = !1, me;
    {
      var ke = typeof WeakMap == "function" ? WeakMap : Map;
      me = new ke();
    }
    function b(n, c) {
      if (!n || pe)
        return "";
      {
        var p = me.get(n);
        if (p !== void 0)
          return p;
      }
      var C;
      pe = !0;
      var j = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var U;
      U = he.current, he.current = null, Le();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (Ee) {
              C = Ee;
            }
            Reflect.construct(n, [], I);
          } else {
            try {
              I.call();
            } catch (Ee) {
              C = Ee;
            }
            n.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ee) {
            C = Ee;
          }
          n();
        }
      } catch (Ee) {
        if (Ee && C && typeof Ee.stack == "string") {
          for (var D = Ee.stack.split(`
`), te = C.stack.split(`
`), H = D.length - 1, K = te.length - 1; H >= 1 && K >= 0 && D[H] !== te[K]; )
            K--;
          for (; H >= 1 && K >= 0; H--, K--)
            if (D[H] !== te[K]) {
              if (H !== 1 || K !== 1)
                do
                  if (H--, K--, K < 0 || D[H] !== te[K]) {
                    var ue = `
` + D[H].replace(" at new ", " at ");
                    return n.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", n.displayName)), typeof n == "function" && me.set(n, ue), ue;
                  }
                while (H >= 1 && K >= 0);
              break;
            }
        }
      } finally {
        pe = !1, he.current = U, je(), Error.prepareStackTrace = j;
      }
      var Me = n ? n.displayName || n.name : "", Yr = Me ? Ce(Me) : "";
      return typeof n == "function" && me.set(n, Yr), Yr;
    }
    function Ae(n, c, p) {
      return b(n, !1);
    }
    function Te(n) {
      var c = n.prototype;
      return !!(c && c.isReactComponent);
    }
    function ye(n, c, p) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return b(n, Te(n));
      if (typeof n == "string")
        return Ce(n);
      switch (n) {
        case v:
          return Ce("Suspense");
        case l:
          return Ce("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case s:
            return Ae(n.render);
          case d:
            return ye(n.type, c, p);
          case P: {
            var C = n, j = C._payload, U = C._init;
            try {
              return ye(U(j), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var Ne = Object.prototype.hasOwnProperty, W = {}, G = x.ReactDebugCurrentFrame;
    function ne(n) {
      if (n) {
        var c = n._owner, p = ye(n.type, n._source, c ? c.type : null);
        G.setExtraStackFrame(p);
      } else
        G.setExtraStackFrame(null);
    }
    function be(n, c, p, C, j) {
      {
        var U = Function.call.bind(Ne);
        for (var I in n)
          if (U(n, I)) {
            var D = void 0;
            try {
              if (typeof n[I] != "function") {
                var te = Error((C || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              D = n[I](c, I, C, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              D = H;
            }
            D && !(D instanceof Error) && (ne(j), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", C || "React class", p, I, typeof D), ne(null)), D instanceof Error && !(D.message in W) && (W[D.message] = !0, ne(j), g("Failed %s type: %s", p, D.message), ne(null));
          }
      }
    }
    var Ve = Array.isArray;
    function hr(n) {
      return Ve(n);
    }
    function kt(n) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return p;
      }
    }
    function Nt(n) {
      try {
        return $r(n), !1;
      } catch {
        return !0;
      }
    }
    function $r(n) {
      return "" + n;
    }
    function Mr(n) {
      if (Nt(n))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", kt(n)), $r(n);
    }
    var Be = x.ReactCurrentOwner, $t = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Dr, Ir, pr;
    pr = {};
    function Mt(n) {
      if (Ne.call(n, "ref")) {
        var c = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function Dt(n) {
      if (Ne.call(n, "key")) {
        var c = Object.getOwnPropertyDescriptor(n, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function It(n, c) {
      if (typeof n.ref == "string" && Be.current && c && Be.current.stateNode !== c) {
        var p = S(Be.current.type);
        pr[p] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', S(Be.current.type), n.ref), pr[p] = !0);
      }
    }
    function Ft(n, c) {
      {
        var p = function() {
          Dr || (Dr = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function Lt(n, c) {
      {
        var p = function() {
          Ir || (Ir = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var jt = function(n, c, p, C, j, U, I) {
      var D = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: n,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: U
      };
      return D._store = {}, Object.defineProperty(D._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(D, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.defineProperty(D, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: j
      }), Object.freeze && (Object.freeze(D.props), Object.freeze(D)), D;
    };
    function Vt(n, c, p, C, j) {
      {
        var U, I = {}, D = null, te = null;
        p !== void 0 && (Mr(p), D = "" + p), Dt(c) && (Mr(c.key), D = "" + c.key), Mt(c) && (te = c.ref, It(c, j));
        for (U in c)
          Ne.call(c, U) && !$t.hasOwnProperty(U) && (I[U] = c[U]);
        if (n && n.defaultProps) {
          var H = n.defaultProps;
          for (U in H)
            I[U] === void 0 && (I[U] = H[U]);
        }
        if (D || te) {
          var K = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          D && Ft(I, K), te && Lt(I, K);
        }
        return jt(n, D, te, j, C, Be.current, I);
      }
    }
    var vr = x.ReactCurrentOwner, Fr = x.ReactDebugCurrentFrame;
    function $e(n) {
      if (n) {
        var c = n._owner, p = ye(n.type, n._source, c ? c.type : null);
        Fr.setExtraStackFrame(p);
      } else
        Fr.setExtraStackFrame(null);
    }
    var gr;
    gr = !1;
    function mr(n) {
      return typeof n == "object" && n !== null && n.$$typeof === r;
    }
    function Lr() {
      {
        if (vr.current) {
          var n = S(vr.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function Bt(n) {
      {
        if (n !== void 0) {
          var c = n.fileName.replace(/^.*[\\\/]/, ""), p = n.lineNumber;
          return `

Check your code at ` + c + ":" + p + ".";
        }
        return "";
      }
    }
    var jr = {};
    function zt(n) {
      {
        var c = Lr();
        if (!c) {
          var p = typeof n == "string" ? n : n.displayName || n.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function Vr(n, c) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var p = zt(c);
        if (jr[p])
          return;
        jr[p] = !0;
        var C = "";
        n && n._owner && n._owner !== vr.current && (C = " It was passed a child from " + S(n._owner.type) + "."), $e(n), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, C), $e(null);
      }
    }
    function Br(n, c) {
      {
        if (typeof n != "object")
          return;
        if (hr(n))
          for (var p = 0; p < n.length; p++) {
            var C = n[p];
            mr(C) && Vr(C, c);
          }
        else if (mr(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var j = N(n);
          if (typeof j == "function" && j !== n.entries)
            for (var U = j.call(n), I; !(I = U.next()).done; )
              mr(I.value) && Vr(I.value, c);
        }
      }
    }
    function Yt(n) {
      {
        var c = n.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === s || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === d))
          p = c.propTypes;
        else
          return;
        if (p) {
          var C = S(c);
          be(p, n.props, "prop", C, n);
        } else if (c.PropTypes !== void 0 && !gr) {
          gr = !0;
          var j = S(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", j || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Wt(n) {
      {
        for (var c = Object.keys(n.props), p = 0; p < c.length; p++) {
          var C = c[p];
          if (C !== "children" && C !== "key") {
            $e(n), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", C), $e(null);
            break;
          }
        }
        n.ref !== null && ($e(n), g("Invalid attribute `ref` supplied to `React.Fragment`."), $e(null));
      }
    }
    function zr(n, c, p, C, j, U) {
      {
        var I = q(n);
        if (!I) {
          var D = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (D += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Bt(j);
          te ? D += te : D += Lr();
          var H;
          n === null ? H = "null" : hr(n) ? H = "array" : n !== void 0 && n.$$typeof === r ? (H = "<" + (S(n.type) || "Unknown") + " />", D = " Did you accidentally export a JSX literal instead of a component?") : H = typeof n, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, D);
        }
        var K = Vt(n, c, p, j, U);
        if (K == null)
          return K;
        if (I) {
          var ue = c.children;
          if (ue !== void 0)
            if (C)
              if (hr(ue)) {
                for (var Me = 0; Me < ue.length; Me++)
                  Br(ue[Me], n);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Br(ue, n);
        }
        return n === o ? Wt(K) : Yt(K), K;
      }
    }
    function Ut(n, c, p) {
      return zr(n, c, p, !0);
    }
    function Gt(n, c, p) {
      return zr(n, c, p, !1);
    }
    var qt = Gt, Ht = Ut;
    We.Fragment = o, We.jsx = qt, We.jsxs = Ht;
  }()), We;
}
process.env.NODE_ENV === "production" ? br.exports = en() : br.exports = rn();
var or = br.exports;
function tn(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function nn(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var on = /* @__PURE__ */ function() {
  function e(t) {
    var o = this;
    this._insertTag = function(a) {
      var i;
      o.tags.length === 0 ? o.insertionPoint ? i = o.insertionPoint.nextSibling : o.prepend ? i = o.container.firstChild : i = o.before : i = o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(a, i), o.tags.push(a);
    }, this.isSpeedy = t.speedy === void 0 ? process.env.NODE_ENV === "production" : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(o) {
    o.forEach(this._insertTag);
  }, r.insert = function(o) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(nn(this));
    var a = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = o.charCodeAt(0) === 64 && o.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + o + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var u = tn(a);
      try {
        u.insertRule(o, u.cssRules.length);
      } catch (f) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(o) && console.error('There was a problem inserting the following rule: "' + o + '"', f);
      }
    } else
      a.appendChild(document.createTextNode(o));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(o) {
      return o.parentNode && o.parentNode.removeChild(o);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), ee = "-ms-", ar = "-moz-", V = "-webkit-", Tr = "comm", Or = "rule", Pr = "decl", an = "@import", lt = "@keyframes", sn = "@layer", cn = Math.abs, cr = String.fromCharCode, un = Object.assign;
function fn(e, r) {
  return Q(e, 0) ^ 45 ? (((r << 2 ^ Q(e, 0)) << 2 ^ Q(e, 1)) << 2 ^ Q(e, 2)) << 2 ^ Q(e, 3) : 0;
}
function dt(e) {
  return e.trim();
}
function ln(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function B(e, r, t) {
  return e.replace(r, t);
}
function Er(e, r) {
  return e.indexOf(r);
}
function Q(e, r) {
  return e.charCodeAt(r) | 0;
}
function qe(e, r, t) {
  return e.slice(r, t);
}
function ve(e) {
  return e.length;
}
function Ar(e) {
  return e.length;
}
function Xe(e, r) {
  return r.push(e), e;
}
function dn(e, r) {
  return e.map(r).join("");
}
var ur = 1, Ie = 1, ht = 0, ae = 0, X = 0, Fe = "";
function fr(e, r, t, o, a, i, u) {
  return { value: e, root: r, parent: t, type: o, props: a, children: i, line: ur, column: Ie, length: u, return: "" };
}
function Ue(e, r) {
  return un(fr("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function hn() {
  return X;
}
function pn() {
  return X = ae > 0 ? Q(Fe, --ae) : 0, Ie--, X === 10 && (Ie = 1, ur--), X;
}
function ie() {
  return X = ae < ht ? Q(Fe, ae++) : 0, Ie++, X === 10 && (Ie = 1, ur++), X;
}
function ge() {
  return Q(Fe, ae);
}
function Ze() {
  return ae;
}
function Ke(e, r) {
  return qe(Fe, e, r);
}
function He(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function pt(e) {
  return ur = Ie = 1, ht = ve(Fe = e), ae = 0, [];
}
function vt(e) {
  return Fe = "", e;
}
function Qe(e) {
  return dt(Ke(ae - 1, wr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function vn(e) {
  for (; (X = ge()) && X < 33; )
    ie();
  return He(e) > 2 || He(X) > 3 ? "" : " ";
}
function gn(e, r) {
  for (; --r && ie() && !(X < 48 || X > 102 || X > 57 && X < 65 || X > 70 && X < 97); )
    ;
  return Ke(e, Ze() + (r < 6 && ge() == 32 && ie() == 32));
}
function wr(e) {
  for (; ie(); )
    switch (X) {
      case e:
        return ae;
      case 34:
      case 39:
        e !== 34 && e !== 39 && wr(X);
        break;
      case 40:
        e === 41 && wr(e);
        break;
      case 92:
        ie();
        break;
    }
  return ae;
}
function mn(e, r) {
  for (; ie() && e + X !== 47 + 10; )
    if (e + X === 42 + 42 && ge() === 47)
      break;
  return "/*" + Ke(r, ae - 1) + "*" + cr(e === 47 ? e : ie());
}
function yn(e) {
  for (; !He(ge()); )
    ie();
  return Ke(e, ae);
}
function bn(e) {
  return vt(er("", null, null, null, [""], e = pt(e), 0, [0], e));
}
function er(e, r, t, o, a, i, u, f, s) {
  for (var v = 0, l = 0, d = u, P = 0, A = 0, k = 0, y = 1, N = 1, x = 1, g = 0, T = "", $ = a, h = i, M = o, O = T; N; )
    switch (k = g, g = ie()) {
      case 40:
        if (k != 108 && Q(O, d - 1) == 58) {
          Er(O += B(Qe(g), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += Qe(g);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += vn(k);
        break;
      case 92:
        O += gn(Ze() - 1, 7);
        continue;
      case 47:
        switch (ge()) {
          case 42:
          case 47:
            Xe(En(mn(ie(), Ze()), r, t), s);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * y:
        f[v++] = ve(O) * x;
      case 125 * y:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            N = 0;
          case 59 + l:
            x == -1 && (O = B(O, /\f/g, "")), A > 0 && ve(O) - d && Xe(A > 32 ? Hr(O + ";", o, t, d - 1) : Hr(B(O, " ", "") + ";", o, t, d - 2), s);
            break;
          case 59:
            O += ";";
          default:
            if (Xe(M = qr(O, r, t, v, l, a, f, T, $ = [], h = [], d), i), g === 123)
              if (l === 0)
                er(O, r, M, M, $, i, d, f, h);
              else
                switch (P === 99 && Q(O, 3) === 110 ? 100 : P) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    er(e, M, M, o && Xe(qr(e, M, M, 0, 0, a, f, T, a, $ = [], d), h), a, h, d, f, o ? $ : h);
                    break;
                  default:
                    er(O, M, M, M, [""], h, 0, f, h);
                }
        }
        v = l = A = 0, y = x = 1, T = O = "", d = u;
        break;
      case 58:
        d = 1 + ve(O), A = k;
      default:
        if (y < 1) {
          if (g == 123)
            --y;
          else if (g == 125 && y++ == 0 && pn() == 125)
            continue;
        }
        switch (O += cr(g), g * y) {
          case 38:
            x = l > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            f[v++] = (ve(O) - 1) * x, x = 1;
            break;
          case 64:
            ge() === 45 && (O += Qe(ie())), P = ge(), l = d = ve(T = O += yn(Ze())), g++;
            break;
          case 45:
            k === 45 && ve(O) == 2 && (y = 0);
        }
    }
  return i;
}
function qr(e, r, t, o, a, i, u, f, s, v, l) {
  for (var d = a - 1, P = a === 0 ? i : [""], A = Ar(P), k = 0, y = 0, N = 0; k < o; ++k)
    for (var x = 0, g = qe(e, d + 1, d = cn(y = u[k])), T = e; x < A; ++x)
      (T = dt(y > 0 ? P[x] + " " + g : B(g, /&\f/g, P[x]))) && (s[N++] = T);
  return fr(e, r, t, a === 0 ? Or : f, s, v, l);
}
function En(e, r, t) {
  return fr(e, r, t, Tr, cr(hn()), qe(e, 2, -2), 0);
}
function Hr(e, r, t, o) {
  return fr(e, r, t, Pr, qe(e, 0, o), qe(e, o + 1, -1), o);
}
function De(e, r) {
  for (var t = "", o = Ar(e), a = 0; a < o; a++)
    t += r(e[a], a, e, r) || "";
  return t;
}
function wn(e, r, t, o) {
  switch (e.type) {
    case sn:
      if (e.children.length)
        break;
    case an:
    case Pr:
      return e.return = e.return || e.value;
    case Tr:
      return "";
    case lt:
      return e.return = e.value + "{" + De(e.children, o) + "}";
    case Or:
      e.value = e.props.join(",");
  }
  return ve(t = De(e.children, o)) ? e.return = e.value + "{" + t + "}" : "";
}
function _n(e) {
  var r = Ar(e);
  return function(t, o, a, i) {
    for (var u = "", f = 0; f < r; f++)
      u += e[f](t, o, a, i) || "";
    return u;
  };
}
function Sn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function Rn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var xn = function(r, t, o) {
  for (var a = 0, i = 0; a = i, i = ge(), a === 38 && i === 12 && (t[o] = 1), !He(i); )
    ie();
  return Ke(r, ae);
}, Cn = function(r, t) {
  var o = -1, a = 44;
  do
    switch (He(a)) {
      case 0:
        a === 38 && ge() === 12 && (t[o] = 1), r[o] += xn(ae - 1, t, o);
        break;
      case 2:
        r[o] += Qe(a);
        break;
      case 4:
        if (a === 44) {
          r[++o] = ge() === 58 ? "&\f" : "", t[o] = r[o].length;
          break;
        }
      default:
        r[o] += cr(a);
    }
  while (a = ie());
  return r;
}, Tn = function(r, t) {
  return vt(Cn(pt(r), t));
}, Jr = /* @__PURE__ */ new WeakMap(), On = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, o = r.parent, a = r.column === o.column && r.line === o.line; o.type !== "rule"; )
      if (o = o.parent, !o)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !Jr.get(o)) && !a) {
      Jr.set(r, !0);
      for (var i = [], u = Tn(t, i), f = o.props, s = 0, v = 0; s < u.length; s++)
        for (var l = 0; l < f.length; l++, v++)
          r.props[v] = i[s] ? u[s].replace(/&\f/g, f[l]) : f[l] + " " + u[s];
    }
  }
}, Pn = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, An = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", kn = function(r) {
  return r.type === "comm" && r.children.indexOf(An) > -1;
}, Nn = function(r) {
  return function(t, o, a) {
    if (!(t.type !== "rule" || r.compat)) {
      var i = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var u = !!t.parent, f = u ? t.parent.children : (
          // global rule at the root level
          a
        ), s = f.length - 1; s >= 0; s--) {
          var v = f[s];
          if (v.line < t.line)
            break;
          if (v.column < t.column) {
            if (kn(v))
              return;
            break;
          }
        }
        i.forEach(function(l) {
          console.error('The pseudo class "' + l + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + l.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, gt = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, $n = function(r, t) {
  for (var o = r - 1; o >= 0; o--)
    if (!gt(t[o]))
      return !0;
  return !1;
}, Kr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, Mn = function(r, t, o) {
  gt(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Kr(r)) : $n(t, o) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Kr(r)));
};
function mt(e, r) {
  switch (fn(e, r)) {
    case 5103:
      return V + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return V + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return V + e + ar + e + ee + e + e;
    case 6828:
    case 4268:
      return V + e + ee + e + e;
    case 6165:
      return V + e + ee + "flex-" + e + e;
    case 5187:
      return V + e + B(e, /(\w+).+(:[^]+)/, V + "box-$1$2" + ee + "flex-$1$2") + e;
    case 5443:
      return V + e + ee + "flex-item-" + B(e, /flex-|-self/, "") + e;
    case 4675:
      return V + e + ee + "flex-line-pack" + B(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return V + e + ee + B(e, "shrink", "negative") + e;
    case 5292:
      return V + e + ee + B(e, "basis", "preferred-size") + e;
    case 6060:
      return V + "box-" + B(e, "-grow", "") + V + e + ee + B(e, "grow", "positive") + e;
    case 4554:
      return V + B(e, /([^-])(transform)/g, "$1" + V + "$2") + e;
    case 6187:
      return B(B(B(e, /(zoom-|grab)/, V + "$1"), /(image-set)/, V + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return B(e, /(image-set\([^]*)/, V + "$1$`$1");
    case 4968:
      return B(B(e, /(.+:)(flex-)?(.*)/, V + "box-pack:$3" + ee + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + V + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return B(e, /(.+)-inline(.+)/, V + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ve(e) - 1 - r > 6)
        switch (Q(e, r + 1)) {
          case 109:
            if (Q(e, r + 4) !== 45)
              break;
          case 102:
            return B(e, /(.+:)(.+)-([^]+)/, "$1" + V + "$2-$3$1" + ar + (Q(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~Er(e, "stretch") ? mt(B(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (Q(e, r + 1) !== 115)
        break;
    case 6444:
      switch (Q(e, ve(e) - 3 - (~Er(e, "!important") && 10))) {
        case 107:
          return B(e, ":", ":" + V) + e;
        case 101:
          return B(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + V + (Q(e, 14) === 45 ? "inline-" : "") + "box$3$1" + V + "$2$3$1" + ee + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Q(e, r + 11)) {
        case 114:
          return V + e + ee + B(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return V + e + ee + B(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return V + e + ee + B(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return V + e + ee + e + e;
  }
  return e;
}
var Dn = function(r, t, o, a) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case Pr:
        r.return = mt(r.value, r.length);
        break;
      case lt:
        return De([Ue(r, {
          value: B(r.value, "@", "@" + V)
        })], a);
      case Or:
        if (r.length)
          return dn(r.props, function(i) {
            switch (ln(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return De([Ue(r, {
                  props: [B(i, /:(read-\w+)/, ":" + ar + "$1")]
                })], a);
              case "::placeholder":
                return De([Ue(r, {
                  props: [B(i, /:(plac\w+)/, ":" + V + "input-$1")]
                }), Ue(r, {
                  props: [B(i, /:(plac\w+)/, ":" + ar + "$1")]
                }), Ue(r, {
                  props: [B(i, /:(plac\w+)/, ee + "input-$1")]
                })], a);
            }
            return "";
          });
    }
}, In = [Dn], Fn = function(r) {
  var t = r.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var o = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(o, function(y) {
      var N = y.getAttribute("data-emotion");
      N.indexOf(" ") !== -1 && (document.head.appendChild(y), y.setAttribute("data-s", ""));
    });
  }
  var a = r.stylisPlugins || In;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var i = {}, u, f = [];
  u = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(y) {
      for (var N = y.getAttribute("data-emotion").split(" "), x = 1; x < N.length; x++)
        i[N[x]] = !0;
      f.push(y);
    }
  );
  var s, v = [On, Pn];
  process.env.NODE_ENV !== "production" && v.push(Nn({
    get compat() {
      return k.compat;
    }
  }), Mn);
  {
    var l, d = [wn, process.env.NODE_ENV !== "production" ? function(y) {
      y.root || (y.return ? l.insert(y.return) : y.value && y.type !== Tr && l.insert(y.value + "{}"));
    } : Sn(function(y) {
      l.insert(y);
    })], P = _n(v.concat(a, d)), A = function(N) {
      return De(bn(N), P);
    };
    s = function(N, x, g, T) {
      l = g, process.env.NODE_ENV !== "production" && x.map !== void 0 && (l = {
        insert: function(h) {
          g.insert(h + x.map);
        }
      }), A(N ? N + "{" + x.styles + "}" : x.styles), T && (k.inserted[x.name] = !0);
    };
  }
  var k = {
    key: t,
    sheet: new on({
      key: t,
      container: u,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: s
  };
  return k.sheet.hydrate(f), k;
}, _r = { exports: {} }, z = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xr;
function Ln() {
  if (Xr)
    return z;
  Xr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, P = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, k = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, N = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function T(h) {
    if (typeof h == "object" && h !== null) {
      var M = h.$$typeof;
      switch (M) {
        case r:
          switch (h = h.type, h) {
            case s:
            case v:
            case o:
            case i:
            case a:
            case d:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case f:
                case l:
                case k:
                case A:
                case u:
                  return h;
                default:
                  return M;
              }
          }
        case t:
          return M;
      }
    }
  }
  function $(h) {
    return T(h) === v;
  }
  return z.AsyncMode = s, z.ConcurrentMode = v, z.ContextConsumer = f, z.ContextProvider = u, z.Element = r, z.ForwardRef = l, z.Fragment = o, z.Lazy = k, z.Memo = A, z.Portal = t, z.Profiler = i, z.StrictMode = a, z.Suspense = d, z.isAsyncMode = function(h) {
    return $(h) || T(h) === s;
  }, z.isConcurrentMode = $, z.isContextConsumer = function(h) {
    return T(h) === f;
  }, z.isContextProvider = function(h) {
    return T(h) === u;
  }, z.isElement = function(h) {
    return typeof h == "object" && h !== null && h.$$typeof === r;
  }, z.isForwardRef = function(h) {
    return T(h) === l;
  }, z.isFragment = function(h) {
    return T(h) === o;
  }, z.isLazy = function(h) {
    return T(h) === k;
  }, z.isMemo = function(h) {
    return T(h) === A;
  }, z.isPortal = function(h) {
    return T(h) === t;
  }, z.isProfiler = function(h) {
    return T(h) === i;
  }, z.isStrictMode = function(h) {
    return T(h) === a;
  }, z.isSuspense = function(h) {
    return T(h) === d;
  }, z.isValidElementType = function(h) {
    return typeof h == "string" || typeof h == "function" || h === o || h === v || h === i || h === a || h === d || h === P || typeof h == "object" && h !== null && (h.$$typeof === k || h.$$typeof === A || h.$$typeof === u || h.$$typeof === f || h.$$typeof === l || h.$$typeof === N || h.$$typeof === x || h.$$typeof === g || h.$$typeof === y);
  }, z.typeOf = T, z;
}
var Y = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zr;
function jn() {
  return Zr || (Zr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, P = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, k = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, N = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function T(b) {
      return typeof b == "string" || typeof b == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      b === o || b === v || b === i || b === a || b === d || b === P || typeof b == "object" && b !== null && (b.$$typeof === k || b.$$typeof === A || b.$$typeof === u || b.$$typeof === f || b.$$typeof === l || b.$$typeof === N || b.$$typeof === x || b.$$typeof === g || b.$$typeof === y);
    }
    function $(b) {
      if (typeof b == "object" && b !== null) {
        var Ae = b.$$typeof;
        switch (Ae) {
          case r:
            var Te = b.type;
            switch (Te) {
              case s:
              case v:
              case o:
              case i:
              case a:
              case d:
                return Te;
              default:
                var ye = Te && Te.$$typeof;
                switch (ye) {
                  case f:
                  case l:
                  case k:
                  case A:
                  case u:
                    return ye;
                  default:
                    return Ae;
                }
            }
          case t:
            return Ae;
        }
      }
    }
    var h = s, M = v, O = f, de = u, se = r, q = l, E = o, m = k, S = A, R = t, w = i, _ = a, F = d, L = !1;
    function Z(b) {
      return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ce(b) || $(b) === s;
    }
    function ce(b) {
      return $(b) === v;
    }
    function xe(b) {
      return $(b) === f;
    }
    function J(b) {
      return $(b) === u;
    }
    function Oe(b) {
      return typeof b == "object" && b !== null && b.$$typeof === r;
    }
    function Le(b) {
      return $(b) === l;
    }
    function je(b) {
      return $(b) === o;
    }
    function he(b) {
      return $(b) === k;
    }
    function Pe(b) {
      return $(b) === A;
    }
    function Ce(b) {
      return $(b) === t;
    }
    function pe(b) {
      return $(b) === i;
    }
    function me(b) {
      return $(b) === a;
    }
    function ke(b) {
      return $(b) === d;
    }
    Y.AsyncMode = h, Y.ConcurrentMode = M, Y.ContextConsumer = O, Y.ContextProvider = de, Y.Element = se, Y.ForwardRef = q, Y.Fragment = E, Y.Lazy = m, Y.Memo = S, Y.Portal = R, Y.Profiler = w, Y.StrictMode = _, Y.Suspense = F, Y.isAsyncMode = Z, Y.isConcurrentMode = ce, Y.isContextConsumer = xe, Y.isContextProvider = J, Y.isElement = Oe, Y.isForwardRef = Le, Y.isFragment = je, Y.isLazy = he, Y.isMemo = Pe, Y.isPortal = Ce, Y.isProfiler = pe, Y.isStrictMode = me, Y.isSuspense = ke, Y.isValidElementType = T, Y.typeOf = $;
  }()), Y;
}
process.env.NODE_ENV === "production" ? _r.exports = Ln() : _r.exports = jn();
var Vn = _r.exports, yt = Vn, Bn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, zn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, bt = {};
bt[yt.ForwardRef] = Bn;
bt[yt.Memo] = zn;
var Yn = !0;
function Wn(e, r, t) {
  var o = "";
  return t.split(" ").forEach(function(a) {
    e[a] !== void 0 ? r.push(e[a] + ";") : o += a + " ";
  }), o;
}
var Et = function(r, t, o) {
  var a = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (o === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Yn === !1) && r.registered[a] === void 0 && (r.registered[a] = t.styles);
}, Un = function(r, t, o) {
  Et(r, t, o);
  var a = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var i = t;
    do
      r.insert(t === i ? "." + a : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Gn(e) {
  for (var r = 0, t, o = 0, a = e.length; a >= 4; ++o, a -= 4)
    t = e.charCodeAt(o) & 255 | (e.charCodeAt(++o) & 255) << 8 | (e.charCodeAt(++o) & 255) << 16 | (e.charCodeAt(++o) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      r ^= (e.charCodeAt(o + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(o + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(o) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var qn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Qr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Hn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Jn = /[A-Z]|^ms/g, wt = /_EMO_([^_]+?)_([^]*?)_EMO_/g, kr = function(r) {
  return r.charCodeAt(1) === 45;
}, et = function(r) {
  return r != null && typeof r != "boolean";
}, yr = /* @__PURE__ */ Rn(function(e) {
  return kr(e) ? e : e.replace(Jn, "-$&").toLowerCase();
}), ir = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(wt, function(o, a, i) {
          return le = {
            name: a,
            styles: i,
            next: le
          }, a;
        });
  }
  return qn[r] !== 1 && !kr(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
if (process.env.NODE_ENV !== "production") {
  var Kn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Xn = ["normal", "none", "initial", "inherit", "unset"], Zn = ir, Qn = /^-ms-/, eo = /-(.)/g, rt = {};
  ir = function(r, t) {
    if (r === "content" && (typeof t != "string" || Xn.indexOf(t) === -1 && !Kn.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== '"' && t.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var o = Zn(r, t);
    return o !== "" && !kr(r) && r.indexOf("-") !== -1 && rt[r] === void 0 && (rt[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Qn, "ms-").replace(eo, function(a, i) {
      return i.toUpperCase();
    }) + "?")), o;
  };
}
var _t = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Je(e, r, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && t.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(_t);
    return t;
  }
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return le = {
          name: t.name,
          styles: t.styles,
          next: le
        }, t.name;
      if (t.styles !== void 0) {
        var o = t.next;
        if (o !== void 0)
          for (; o !== void 0; )
            le = {
              name: o.name,
              styles: o.styles,
              next: le
            }, o = o.next;
        var a = t.styles + ";";
        return process.env.NODE_ENV !== "production" && t.map !== void 0 && (a += t.map), a;
      }
      return ro(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var i = le, u = t(e);
        return le = i, Je(e, r, u);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var f = [], s = t.replace(wt, function(l, d, P) {
          var A = "animation" + f.length;
          return f.push("const " + A + " = keyframes`" + P.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + A + "}";
        });
        f.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(f, ["`" + s + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + s + "`"));
      }
      break;
  }
  if (r == null)
    return t;
  var v = r[t];
  return v !== void 0 ? v : t;
}
function ro(e, r, t) {
  var o = "";
  if (Array.isArray(t))
    for (var a = 0; a < t.length; a++)
      o += Je(e, r, t[a]) + ";";
  else
    for (var i in t) {
      var u = t[i];
      if (typeof u != "object")
        r != null && r[u] !== void 0 ? o += i + "{" + r[u] + "}" : et(u) && (o += yr(i) + ":" + ir(i, u) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(_t);
        if (Array.isArray(u) && typeof u[0] == "string" && (r == null || r[u[0]] === void 0))
          for (var f = 0; f < u.length; f++)
            et(u[f]) && (o += yr(i) + ":" + ir(i, u[f]) + ";");
        else {
          var s = Je(e, r, u);
          switch (i) {
            case "animation":
            case "animationName": {
              o += yr(i) + ":" + s + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Hn), o += i + "{" + s + "}";
          }
        }
      }
    }
  return o;
}
var tt = /label:\s*([^\s;\n{]+)\s*(;|$)/g, St;
process.env.NODE_ENV !== "production" && (St = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var le, nt = function(r, t, o) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var a = !0, i = "";
  le = void 0;
  var u = r[0];
  u == null || u.raw === void 0 ? (a = !1, i += Je(o, t, u)) : (process.env.NODE_ENV !== "production" && u[0] === void 0 && console.error(Qr), i += u[0]);
  for (var f = 1; f < r.length; f++)
    i += Je(o, t, r[f]), a && (process.env.NODE_ENV !== "production" && u[f] === void 0 && console.error(Qr), i += u[f]);
  var s;
  process.env.NODE_ENV !== "production" && (i = i.replace(St, function(P) {
    return s = P, "";
  })), tt.lastIndex = 0;
  for (var v = "", l; (l = tt.exec(i)) !== null; )
    v += "-" + // $FlowFixMe we know it's not null
    l[1];
  var d = Gn(i) + v;
  return process.env.NODE_ENV !== "production" ? {
    name: d,
    styles: i,
    map: s,
    next: le,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: d,
    styles: i,
    next: le
  };
}, to = function(r) {
  return r();
}, no = we["useInsertionEffect"] ? we["useInsertionEffect"] : !1, oo = no || to, lr = {}.hasOwnProperty, Nr = /* @__PURE__ */ we.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Fn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Nr.displayName = "EmotionCacheContext");
Nr.Provider;
var ao = function(r) {
  return /* @__PURE__ */ sr(function(t, o) {
    var a = Jt(Nr);
    return r(t, a, o);
  });
}, Rt = /* @__PURE__ */ we.createContext({});
process.env.NODE_ENV !== "production" && (Rt.displayName = "EmotionThemeContext");
var ot = function(r) {
  var t = r.split(".");
  return t[t.length - 1];
}, io = function(r) {
  var t = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (t || (t = /^([A-Za-z0-9$.]+)@/.exec(r), t))
    return ot(t[1]);
}, so = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), co = function(r) {
  return r.replace(/\$/g, "-");
}, uo = function(r) {
  if (r)
    for (var t = r.split(`
`), o = 0; o < t.length; o++) {
      var a = io(t[o]);
      if (a) {
        if (so.has(a))
          break;
        if (/^[A-Z]/.test(a))
          return co(a);
      }
    }
}, Sr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Rr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", xt = function(r, t) {
  if (process.env.NODE_ENV !== "production" && typeof t.css == "string" && // check if there is a css declaration
  t.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + t.css + "`");
  var o = {};
  for (var a in t)
    lr.call(t, a) && (o[a] = t[a]);
  if (o[Sr] = r, process.env.NODE_ENV !== "production" && t.css && (typeof t.css != "object" || typeof t.css.name != "string" || t.css.name.indexOf("-") === -1)) {
    var i = uo(new Error().stack);
    i && (o[Rr] = i);
  }
  return o;
}, fo = function(r) {
  var t = r.cache, o = r.serialized, a = r.isStringTag;
  return Et(t, o, a), oo(function() {
    return Un(t, o, a);
  }), null;
}, Ct = /* @__PURE__ */ ao(function(e, r, t) {
  var o = e.css;
  typeof o == "string" && r.registered[o] !== void 0 && (o = r.registered[o]);
  var a = e[Sr], i = [o], u = "";
  typeof e.className == "string" ? u = Wn(r.registered, i, e.className) : e.className != null && (u = e.className + " ");
  var f = nt(i, void 0, we.useContext(Rt));
  if (process.env.NODE_ENV !== "production" && f.name.indexOf("-") === -1) {
    var s = e[Rr];
    s && (f = nt([f, "label:" + s + ";"]));
  }
  u += r.key + "-" + f.name;
  var v = {};
  for (var l in e)
    lr.call(e, l) && l !== "css" && l !== Sr && (process.env.NODE_ENV === "production" || l !== Rr) && (v[l] = e[l]);
  return v.ref = t, v.className = u, /* @__PURE__ */ we.createElement(we.Fragment, null, /* @__PURE__ */ we.createElement(fo, {
    cache: r,
    serialized: f,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ we.createElement(a, v));
});
process.env.NODE_ENV !== "production" && (Ct.displayName = "EmotionCssPropInternal");
var Tt = Ct;
function re(e, r, t) {
  return lr.call(r, "css") ? or.jsx(Tt, xt(e, r), t) : or.jsx(e, r, t);
}
function lo(e, r, t) {
  return lr.call(r, "css") ? or.jsxs(Tt, xt(e, r), t) : or.jsxs(e, r, t);
}
const ho = [
  "white",
  "blackAlpha",
  "gray",
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "cyan",
  "purple",
  "grayBlue",
  "techPurple",
  "techPink"
];
function dr(e, r) {
  return r ? `${Ge("gray", "08")}` : e ? ho.includes(e) ? `${Ge(e, "03")}` : e : `${Ge("blue", "03")}`;
}
const po = Re`
  width: 100%;
  height: 40px;
  box-sizing: content-box;
  display: flex;
  align-items: center;
`;
function vo() {
  return Re`
    width: 100%;
    height: 2px;
    background-color: ${Ge("gray", "08")};
    border-radius: 2px;
    display: flex;
    align-items: center;
    position: relative;
  `;
}
function go(e, r, t, o) {
  return Re`
    height: 2px;
    position: absolute;
    width: ${t}px;
    background: ${dr(o, e)};
    border-radius: 2px;
    cursor: ${e || !r ? "auto" : "pointer"};
  `;
}
function mo(e, r) {
  return Re`
    box-sizing: border-box;
    height: 12px;
    width: 12px;
    background-color: white;
    border: 2px solid ${dr(r, e)};
    border-radius: 50%;
    position: absolute;
    z-index: 2;
    cursor: ${e ? "auto" : "pointer"};
    transition: width 150ms ease-in-out, height 150ms ease-in-out;
    &:hover {
      height: 16px;
      width: 16px;
    }
    &[data-location="right"]:focus-within {
      height: 16px;
      width: 16px;
    }
  `;
}
function at(e, r, t) {
  return Re`
    box-sizing: border-box;
    position: absolute;
    left: ${r ? "auto" : 0}px;
    right: ${r ? 0 : "auto"}px;
    height: 8px;
    width: 8px;
    background-color: white;
    border: 2px solid ${dr(t, e)};
    border-radius: 50%;
    z-index: 1;
    transform: ${r ? "translateX(50%)" : "translateX(-50%)"};
    cursor: ${e ? "auto" : "pointer"};
  `;
}
const yo = Re`
  height: 100%;
  width: 100%;
`;
function bo(e, r) {
  return Re`
    height: 5px;
    width: 8px;
    position: absolute;
    left: ${e}px;
    bottom: 100%;
    transform: translateX(-50%);
    cursor: ${r ? "auto" : "pointer"};
  `;
}
function Eo(e) {
  return Re`
    height: 5px;
    width: 2px;
    background: ${e};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  `;
}
function wo(e, r) {
  return Re`
    height: 22px;
    width: 15px;
    position: absolute;
    font-size: 14px;
    margin-top: 4px;
    line-height: 22px;
    text-align: center;
    color: ${Ge("gray", "02")};
    top: 100%;
    left: ${e}px;
    transform: translateX(-50%);
    cursor: ${r ? "auto" : "pointer"};
  `;
}
const Ot = sr((e, r) => {
  const { isRange: t, dragBar: o, value: a, left: i, width: u, disabled: f, containerWidth: s, partLength: v, colorScheme: l, onDragBarEnd: d } = e, P = _e([]), A = ut(0), k = () => {
    !t || ze(t) && !t.draggableBar || (P.current = a);
  }, y = (x, g) => {
    if (!t || !(ze(t) && t.draggableBar) || f)
      return;
    const { offset: { x: T } } = g;
    o(T, P.current);
  }, N = (x, g) => {
    if (!t || !(ze(t) && t.draggableBar))
      return;
    const { offset: { x: T } } = g;
    d(T, P.current);
  };
  return Se(() => {
    A.set(i);
  }, [i, t, A]), re(ft.div, { drag: !f && ze(t) && t.draggableBar ? "x" : !1, ref: r, onDragStart: k, onDrag: y, onDragEnd: N, css: go(f, ze(t) && t.draggableBar, u, l), dragElastic: !1, dragConstraints: { left: 0, right: s - u }, style: { x: A }, dragMomentum: !1, dragTransition: {
    timeConstant: 200,
    power: 0,
    modifyTarget: (x) => Math.round(x / v) * v
  } });
});
Ot.displayName = "Bar";
const _o = 240;
var oe;
(function(e) {
  e.LEFT = "left", e.RIGHT = "right";
})(oe || (oe = {}));
const So = (e, r) => typeof e != "number" && !e ? 0 : typeof e == "number" ? e : Array.from(e.split(","), (t) => Pt(r) !== 0 ? rr(parseFloat(t), r) : parseInt(t)), Ro = (e, r, t, o, a, i) => {
  if (Array.isArray(r))
    switch (t) {
      default:
      case oe.RIGHT:
        return {
          left: Math.round(r[0] / i + 1) * o - e,
          right: Math.floor(a / i) * o - e
        };
      case oe.LEFT:
        return {
          left: -e,
          right: Math.floor((r[1] - i) / i) * o
        };
    }
  return {
    left: -e,
    right: Math.floor(a / i) * o
  };
}, xo = (e, r, t, o, a) => o >= e ? e : a === void 0 && o <= r ? r : o, Co = (e, r, t, o, a) => a === void 0 ? a : a <= r ? r : a >= e ? e : a, it = (e) => e && e > 0 ? e : 1, Pt = (e) => {
  if (Number.isInteger(e))
    return 0;
  {
    const r = e.toString(), t = r.indexOf(".");
    return t === -1 ? 0 : r.length - t - 1;
  }
}, rr = (e, r) => {
  const t = Pt(r);
  return t === 0 ? Math.floor(e) : parseFloat(e.toFixed(t));
};
function xr(e, r, t) {
  var o, a, i, u, f;
  r == null && (r = 100);
  function s() {
    var l = Date.now() - u;
    l < r && l >= 0 ? o = setTimeout(s, r - l) : (o = null, t || (f = e.apply(i, a), i = a = null));
  }
  var v = function() {
    i = this, a = arguments, u = Date.now();
    var l = t && !o;
    return o || (o = setTimeout(s, r)), l && (f = e.apply(i, a), i = a = null), f;
  };
  return v.clear = function() {
    o && (clearTimeout(o), o = null);
  }, v.flush = function() {
    o && (f = e.apply(i, a), i = a = null, clearTimeout(o), o = null);
  }, v;
}
xr.debounce = xr;
var To = xr;
const st = /* @__PURE__ */ Qt(To);
function Oo(e) {
  let {
    debounce: r,
    scroll: t,
    polyfill: o,
    offsetSize: a
  } = e === void 0 ? {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
  } : e;
  const i = o || (typeof window > "u" ? class {
  } : window.ResizeObserver);
  if (!i)
    throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
  const [u, f] = fe({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    bottom: 0,
    right: 0,
    x: 0,
    y: 0
  }), s = _e({
    element: null,
    scrollContainers: null,
    resizeObserver: null,
    lastBounds: u
  }), v = r ? typeof r == "number" ? r : r.scroll : null, l = r ? typeof r == "number" ? r : r.resize : null, d = _e(!1);
  Se(() => (d.current = !0, () => void (d.current = !1)));
  const [P, A, k] = tr(() => {
    const g = () => {
      if (!s.current.element)
        return;
      const {
        left: T,
        top: $,
        width: h,
        height: M,
        bottom: O,
        right: de,
        x: se,
        y: q
      } = s.current.element.getBoundingClientRect(), E = {
        left: T,
        top: $,
        width: h,
        height: M,
        bottom: O,
        right: de,
        x: se,
        y: q
      };
      s.current.element instanceof HTMLElement && a && (E.height = s.current.element.offsetHeight, E.width = s.current.element.offsetWidth), Object.freeze(E), d.current && !No(s.current.lastBounds, E) && f(s.current.lastBounds = E);
    };
    return [g, l ? st(g, l) : g, v ? st(g, v) : g];
  }, [f, a, v, l]);
  function y() {
    s.current.scrollContainers && (s.current.scrollContainers.forEach((g) => g.removeEventListener("scroll", k, !0)), s.current.scrollContainers = null), s.current.resizeObserver && (s.current.resizeObserver.disconnect(), s.current.resizeObserver = null);
  }
  function N() {
    s.current.element && (s.current.resizeObserver = new i(k), s.current.resizeObserver.observe(s.current.element), t && s.current.scrollContainers && s.current.scrollContainers.forEach((g) => g.addEventListener("scroll", k, {
      capture: !0,
      passive: !0
    })));
  }
  const x = (g) => {
    !g || g === s.current.element || (y(), s.current.element = g, s.current.scrollContainers = At(g), N());
  };
  return Ao(k, !!t), Po(A), Se(() => {
    y(), N();
  }, [t, k, A]), Se(() => y, []), [x, u, P];
}
function Po(e) {
  Se(() => {
    const r = e;
    return window.addEventListener("resize", r), () => void window.removeEventListener("resize", r);
  }, [e]);
}
function Ao(e, r) {
  Se(() => {
    if (r) {
      const t = e;
      return window.addEventListener("scroll", t, {
        capture: !0,
        passive: !0
      }), () => void window.removeEventListener("scroll", t, !0);
    }
  }, [e, r]);
}
function At(e) {
  const r = [];
  if (!e || e === document.body)
    return r;
  const {
    overflow: t,
    overflowX: o,
    overflowY: a
  } = window.getComputedStyle(e);
  return [t, o, a].some((i) => i === "auto" || i === "scroll") && r.push(e), [...r, ...At(e.parentElement)];
}
const ko = ["x", "y", "top", "bottom", "left", "right", "width", "height"], No = (e, r) => ko.every((t) => e[t] === r[t]), Cr = sr((e, r) => {
  const { markBarRef: t, isRange: o, left: a, right: i, dragEnd: u, value: f, location: s, disabled: v, currentWidth: l, step: d, max: P, partLength: A, colorScheme: k, drag: y, mouseEnter: N, mouseOut: x, rerenderPosition: g } = e, T = _e(0), $ = ut(0), [h, M] = Oo(), O = () => {
    v || (T.current = f);
  }, de = (q, E) => {
    if (v)
      return;
    const { offset: { x: m } } = E;
    y(m - M.width / 2, T.current, s);
  }, se = (q, E) => {
    if (v)
      return;
    const { offset: { x: m } } = E;
    u(m - M.width / 2, T.current, s);
  };
  return Se(() => {
    if (o) {
      if (l && i !== -1 && s === oe.RIGHT && $.get() !== l - i - M.width / 2) {
        $.set(l - i - M.width / 2);
        return;
      }
      if (l && a !== -1 && s === oe.LEFT && $.get() !== a - M.width / 2) {
        $.set(a - M.width / 2);
        return;
      }
    } else if ($.get() !== l - i - M.width / 2) {
      $.set(l - i - M.width / 2);
      return;
    }
  }), re(ft.div, { drag: "x", ref: Xt(h, t, r), tabIndex: -1, onDragStart: O, onDrag: de, onDragEnd: se, onMouseDown: (q) => {
    q.stopPropagation();
  }, onTouchStart: (q) => q.stopPropagation(), onMouseDownCapture: (q) => q.stopPropagation(), onTouchStartCapture: (q) => q.stopPropagation(), onUpdate: () => {
    g && g();
  }, "data-location": s, css: mo(v, k), dragElastic: 0, dragConstraints: Ro(M.width / 2, f, s, A, P, d), style: { x: $, zIndex: 2 }, dragMomentum: !1, dragTransition: {
    timeConstant: 0,
    power: 0,
    modifyTarget: (q) => Math.round(q / A) * A - M.width / 2
  }, children: re("div", { css: yo, onMouseEnter: N, onMouseOut: x }) });
});
Cr.displayName = "MarkBar";
const $o = (e) => {
  const { left: r, leftValue: t, rightValue: o, currentWidth: a, disabled: i, colorScheme: u, value: f } = e, s = a - o >= r, v = dr(u, !(t <= r && s && !i));
  return re("div", { css: bo(r, i), "data-value": f, children: re("div", { css: Eo(v) }) });
}, Mo = (e, r, t) => {
  const [o, a] = fe(0), [i, u] = fe(-1), [f, s] = fe(0), [v, l] = fe(""), [d, P] = fe(0), [A, k] = fe(0), y = tr(() => So(v, t), [v, t]), N = nr((E, m) => {
    let S = xo(r, e, t, E, m), R = Co(r, e, t, E, m), w, _, F;
    return R !== void 0 ? (w = Math.round((R - e) / t * d), _ = Math.floor((r - S) / t * d), F = Math.round((S - R) / t * d)) : (w = 0, _ = Math.floor((r - S) / t * d), F = A - _), [w, _, F];
  }, [r, e, d, t, A]), x = nr((E, m, S, R) => {
    const [w, _, F] = N(S, R);
    a(w), s(F), u(_), P(E), l(R !== void 0 ? `${R},${S}` : S), k(m);
  }, [N]), g = (E, m, S) => {
    Array.isArray(m) ? $(E, m, S) : T(E, m);
  }, T = (E, m) => {
    let S = Math.floor((e - m) / t) * d, R = Math.floor((r - m) / t) * d, w, _ = Math.round(E / d) * d;
    _ >= R ? w = R : _ <= S ? w = S : w = _, M(E, m), s(Math.round((m - e) / t) * d + w);
  }, $ = (E, m, S) => {
    let R, w, _, F = Math.round(E / d) * d;
    switch (S) {
      case oe.LEFT: {
        R = Math.floor((e - m[0]) / t) * d, w = Math.floor((m[1] - m[0] - t) / t) * d, F >= w ? _ = w : F <= R ? _ = R : _ = F, O(E, m, oe.LEFT), s(Math.round((m[1] - m[0]) / t) * d - _);
        break;
      }
      default:
      case oe.RIGHT: {
        R = Math.floor((m[0] - m[1] + t) / t) * d, w = Math.floor((r - m[1]) / t) * d, F >= w ? _ = w : F <= R ? _ = R : _ = F, O(E, m, oe.RIGHT), s(Math.round((m[1] - m[0]) / t) * d + _);
        break;
      }
    }
  }, h = (E, m, S, R, w) => {
    Array.isArray(m) ? O(E, m, S, R, w) : M(E, m, R, w);
  }, M = (E, m, S, R) => {
    let w = m + Math.round(E / d) * t, _, F = Math.floor(r / t) * t;
    w >= F ? _ = F : w <= e ? _ = e : _ = w;
    const L = rr(_, t);
    S && S(L), R && R(L), l(L);
    let [Z, ce] = N(_);
    u(ce);
  }, O = (E, m, S, R, w) => {
    let _, [F, L] = m;
    switch (S) {
      case oe.RIGHT:
      default: {
        let J = m[1] + Math.round(E / d) * t;
        J >= Math.floor(r / t) * t ? _ = [F, Math.floor(r / t) * t] : J <= F + t ? _ = [F, F + t] : _ = [F, J];
        break;
      }
      case oe.LEFT: {
        let J = m[0] + Math.round(E / d) * t;
        L - 1 <= J ? _ = [L - t, L] : J <= e ? _ = [e, Math.max(F, L)] : _ = [J, L];
        break;
      }
    }
    const Z = _.map((J) => rr(J, t));
    R && R(Z), w && w(Z), l(Z.join(","));
    let [ce, xe] = N(_[1], _[0]);
    a(ce), u(xe);
  };
  return {
    currentValue: y,
    leftOffset: o,
    rightOffset: i,
    barLength: f,
    partLength: d,
    initOffsetFromState: x,
    onDragging: g,
    onDragEnd: h,
    onClickTick: (E) => {
      if (Array.isArray(y)) {
        let m = Math.floor((y[1] - y[0]) / 2) + y[0];
        if (E > m) {
          const [S, R, w] = N(E, y[0]);
          l(`${y[0]},${E}`), u(R), s(w);
        } else {
          const [S, R, w] = N(y[1], E);
          l(`${E},${y[1]}`), a(S), s(w);
        }
      } else {
        const [m, S, R] = N(E);
        l(E), a(m), s(R), u(S);
      }
    },
    onDragBar: (E, m) => {
      let S = Math.round((e - m[0]) / t) * d, R = Math.floor((r - m[1]) / t) * d, w, _ = Math.round(E / d) * d;
      _ >= R ? w = R : _ <= S ? w = S : w = _, u(R - w), a(Math.round(m[0] / t) * d + w);
    },
    onDragBarEnd: (E, m, S) => {
      const w = m.map((_, F) => {
        const L = _ + Math.round(E / d) * t;
        if (F === 0) {
          let Z = r - (m[1] - m[0]);
          return L <= e ? e : L >= Z ? Z : L;
        } else {
          let Z = e + (m[1] - m[0]);
          return L <= Z ? Z : L >= r ? r : L;
        }
      }).map((_) => rr(_, t));
      S && S(w), l(w.join(","));
    }
  };
}, Do = (e) => {
  const { left: r, disabled: t, value: o } = e;
  return re("div", { css: wo(r, t), "data-value": o, children: o });
}, Io = (e) => {
  const [r, t] = fe(0);
  return Se(() => {
    if (e.current) {
      const o = new ResizeObserver((a) => {
        const { width: i } = a[0].contentRect;
        t(i);
      });
      return o.observe(e.current), () => {
        e.current && o.unobserve(e.current);
      };
    }
  }, [e]), r;
}, Fo = sr((e, r) => {
  const { disabled: t = !1, tooltipVisible: o = !0, showTicks: a = !1, hideValue: i = !1, max: u = 10, min: f = 0, step: s = 1, tooltipPosition: v = "top", defaultValue: l = 0, value: d = l, isRange: P = Array.isArray(d), startMarkShow: A = !1, endMarkShow: k = !1, colorScheme: y, formatTooltip: N = (W) => W, onAfterChange: x, onChange: g } = e, [T, $] = fe(_o), h = _e(null), M = _e(null), [O, de] = fe(void 0), se = _e(null), q = _e(), E = _e(), [m, S] = fe(!1), [R, w] = fe(!1), _ = tr(() => Array.isArray(d) ? d[0] : void 0, [d]), F = tr(() => Array.isArray(d) ? d[1] : d, [d]), { currentValue: L, leftOffset: Z, rightOffset: ce, barLength: xe, partLength: J, initOffsetFromState: Oe, onDragging: Le, onDragEnd: je, onClickTick: he, onDragBar: Pe, onDragBarEnd: Ce } = Mo(f, u, it(s)), pe = Io(h);
  Kt(r, () => ({
    focus: () => {
      var W;
      S(!0), (W = M.current) == null || W.focus();
    }
  }));
  const me = (W, G, ne) => {
    Le(W, G, ne);
  }, ke = (W, G, ne) => {
    var be;
    (be = M.current) == null || be.blur(), je(W, G, ne, x, g);
  }, b = (W, G) => {
    Pe(W, G);
  }, Ae = (W, G) => {
    Ce(W, G, x);
  }, Te = (W) => {
    const { target: G } = W;
    if (G) {
      const { dataset: ne } = G;
      if (ne && ne.value !== void 0) {
        he(parseInt(ne.value));
        return;
      }
      const { parentElement: be } = G, Ve = be == null ? void 0 : be.dataset;
      be && Ve && Ve.value !== void 0 && he(parseInt(Ve.value));
    }
  }, ye = nr(() => {
    var W;
    q && ((W = q.current) == null || W.rerenderPosition());
  }, []), Ne = nr(() => {
    var W;
    E && ((W = E.current) == null || W.rerenderPosition());
  }, []);
  return Se(() => {
    if (se.current) {
      const W = it(s), G = Math.ceil((u - f) / W), ne = pe / ((u - f) / W);
      de(G), $(pe), Oe(ne, pe, F, _);
    }
  }, [
    P,
    u,
    f,
    s,
    Oe,
    _,
    F,
    pe
  ]), re("div", { ref: h, css: [po, Zt(e)], children: lo("div", { css: vo(), ref: se, onClick: Te, children: [a && O && O > 0 && [...new Array(O - 1)].map((W, G) => re($o, { value: (G + 1) * s, left: (G + 1) * J, leftValue: Z, rightValue: ce, currentWidth: T, colorScheme: y, disabled: t }, G)), a && O && O > 0 && [...new Array(O + 1)].map((W, G) => G <= Math.floor((u - f) / s) && re(Do, { value: f + G * s, left: G * J, disabled: t }, G)), A && re("div", { css: at(!1, t), onClick: () => he(f) }), !!P && re(Wr, { content: Array.isArray(L) ? N(L[0]) : N(L), position: v, triggerRef: E, popupVisible: R && o, children: re(Cr, { isRange: P, left: Z, right: -1, drag: me, dragEnd: ke, value: L, location: oe.LEFT, disabled: t, max: u, min: f, step: s, currentWidth: T, partLength: J, colorScheme: y, mouseEnter: () => w(!0), mouseOut: () => w(!1), rerenderPosition: Ne }) }), re(Wr, { content: Array.isArray(L) ? N(L[1]) : N(L), triggerRef: q, position: v, popupVisible: m && o, children: re(Cr, { right: ce, left: -1, isRange: P, drag: me, dragEnd: ke, markBarRef: M, value: L, max: u, min: f, step: s, location: oe.RIGHT, disabled: t, currentWidth: T, partLength: J, colorScheme: y, mouseEnter: () => S(!0), mouseOut: () => S(!1), rerenderPosition: ye }) }), k && re("div", { css: at(!0, t), onClick: () => he(u) }), re(Ot, { width: xe, left: Z, isRange: P, value: L, dragBar: b, disabled: t, colorScheme: y, containerWidth: T, partLength: J, onDragBarEnd: Ae })] }) });
});
Fo.displayName = "Slider";
export {
  Fo as Slider
};
//# sourceMappingURL=index.js.map
